/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Membersapprovedall2Inputs */

const en_membersapprovedall2 = /** @type {(inputs: Membersapprovedall2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} accepted`)
};

const de_membersapprovedall2 = /** @type {(inputs: Membersapprovedall2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} angenommen`)
};

/**
* | output |
* | --- |
* | "{count} accepted" |
*
* @param {Membersapprovedall2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const membersapprovedall2 = /** @type {((inputs: Membersapprovedall2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membersapprovedall2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_membersapprovedall2(inputs)
	return de_membersapprovedall2(inputs)
});
export { membersapprovedall2 as "membersApprovedAll" }